import { css } from '@emotion/core';

export const starRating = (gap: number = 1) => css`
  font-size: 0;

  & > *:not(:first-of-type) {
    margin-left: ${gap}px;
  }
`;

export const starWrapper = css`
  display: inline-block;
  font-size: 0;
`;
